import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Col,
  Row,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import SettingsEditButtons from '../EditButtons';
import SettingsItemsWrapper from '../Item/ItemsWrapper';
import TrialNotice from '../../../TrialNotice';
import UpgradePlanButton from '../../../UpgradePlanButton';

const SettingsBasicSection = (props) => {
  const {
    activeTab,
    saving,
    handleSave,
    unsaved,
    title,
    description,
    trialNoticeFeature,
  } = props;

  const intl = useIntl();

  return (
    <>
      <div className="settings-inner-content">
        <Row>
          <Col>
            <h3>
              {title}
              {activeTab === 'public-urls' && (
                <UpgradePlanButton feature="public-file-urls" />
              )}
            </h3>
            {trialNoticeFeature && (
              <TrialNotice feature={trialNoticeFeature} className="pl-0" />
            )}
            {description && (
              <p>{description}</p>
            )}
            {activeTab === '2fa' && (
              <p>
                {intl.formatMessage({ defaultMessage: 'You can enable 2FA for your account only in your profile settings area <link>here</link>' }, {
                  link: (msg) => (
                    <Link to="/profile/edit?tab=2fa">
                      {msg}
                    </Link>
                  ),
                })}
              </p>
            )}
          </Col>
        </Row>
        <SettingsItemsWrapper
          {...props}
        />
      </div>
      <SettingsEditButtons
        saving={saving}
        handleSave={handleSave}
        unsaved={unsaved}
      />
    </>
  );
};

SettingsBasicSection.propTypes = {
  activeTab: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  handleSettingChange: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  hiddenSettings: PropTypes.array.isRequired,
  errors: PropTypes.object.isRequired,
  setErrors: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  unsaved: PropTypes.bool.isRequired,
  trialNoticeFeature: PropTypes.string,
};

SettingsBasicSection.defaultProps = {
  description: '',
  trialNoticeFeature: '',
};

export default SettingsBasicSection;
